import { Outlet, useLocation } from "react-router-dom";
import HousekeepingMainPage from "../../components/housekeepingV2/HousekeepingMainPage";
import OutOfOrderRoomsPage from "./OutOfOrderRoomsPage";
import { useEffect } from "react";

const Index = () => {
  const location = useLocation();
  if(location.pathname.endsWith("/house-keeping/out-of-order")) {
    return (<OutOfOrderRoomsPage />);
  }
  return<div> <HousekeepingMainPage />
  <Outlet/>
  </div>;
};

export default Index;
